import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

interface UploadDocumentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function UploadDocumentDialog({ open, onOpenChange }: UploadDocumentDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Upload Document</DialogTitle>
          <DialogDescription>
            Upload and manage your documents
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-6">
          <div className="bg-secondary rounded-full p-4">
            <Upload className="h-10 w-10 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground text-center">
            Head to the Documents page to upload and manage your files.
          </p>
          <Button onClick={() => { onOpenChange(false); navigate('/documents'); }}>
            Go to Documents
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
